import * as React from 'react';

const newsletterIconSmall = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="4" fill="white" />
    <path
      d="M18.2677 6.49396C18.5798 6.28377 19 6.50739 19 6.88366V14.6064C19 15.3022 18.7369 15.9716 18.2644 16.4778C17.792 16.984 17.1459 17.2887 16.4584 17.3295L16.3 17.3341H3.7C3.01131 17.3341 2.34864 17.0683 1.84757 16.591C1.34649 16.1137 1.0449 15.461 1.0045 14.7664L1 14.6064V6.88366C1 6.50739 1.42023 6.28377 1.73231 6.49396L9.5005 11.726L9.6049 11.7861C9.72793 11.8468 9.86306 11.8783 10 11.8783C10.1369 11.8783 10.2721 11.8468 10.3951 11.7861L10.4995 11.726L18.2677 6.49396Z"
      fill="url(#paint0_linear_23111_840)"
    />
    <path
      d="M16.0596 3C16.8302 3 17.5247 3.32921 18.0118 3.85652C18.214 4.07549 18.1376 4.41226 17.8903 4.57866L10.1435 9.79079C9.95547 9.91728 9.70957 9.91728 9.52156 9.79079L1.7746 4.57857C1.52733 4.4122 1.45083 4.0755 1.65307 3.8566C1.8211 3.67474 2.01386 3.51661 2.22629 3.38729C2.59057 3.16552 3.00212 3.03488 3.42661 3.00628L3.60541 3H16.0596Z"
      fill="url(#paint1_linear_23111_840)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_23111_840"
        x1="16.1667"
        y1="15.5972"
        x2="-2.11847"
        y2="4.2452"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2744FF" />
        <stop offset="1" stopColor="#B9D5FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_23111_840"
        x1="13.8325"
        y1="8.16667"
        x2="4.33252"
        y2="-5.83333"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

export default newsletterIconSmall; 
